import ApiClient from '@lib/apiClient';

import { downloadBlobFIle, printApiError } from '@utils/Util';

export const removeRangePlanItem = async (itemId) => {
	try {
		const { data } = await ApiClient.DELETE('removeRangePlanItem', {}, itemId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const toggleTarget = async (entityId, entityType, showTargetInfo) => {
	try {
		const queryParams = `${entityId}?showTargetInfo=${showTargetInfo}&entityType=${entityType}`;
		const { data } = await ApiClient.POST('toggleTarget', {}, queryParams);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchRangePlanTableData = async (entityId, entityType) => {
	try {
		const queryParams = `${entityId}?entityType=${entityType}`;
		const { data } = await ApiClient.GET('getRangePlanTableData', queryParams);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateRangePlaningTarget = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('updateRangePlaningTarget', requestBody);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchFitTypeTags = async (searchText = '') => {
	try {
		const queryParams = `?type=PRODUCT_FITTING_TYPE&search=${encodeURIComponent(searchText)}`;
		const { data } = await ApiClient.GET('fitTypeTags', queryParams);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadRangePlan = async (entityId, entityType) => {
	try {
		const path = `${entityId}/download-excel?entityType=${entityType}`;
		const response = await ApiClient.DOWNLOAD_GET('downloadRangePlan', path);
		downloadBlobFIle(response);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const addRangePlanItem = async (requestBody, brandId) => {
	const queryParams = `?brandId=${brandId}`;
	try {
		const { data } = await ApiClient.POST('addRangePlanItem', requestBody, queryParams);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
